import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer'

const useCurrentFolderId = () : string | undefined => {
  const folderDb = useSelector((state: RootState) => state.folderDb)
  if (folderDb.currentFolderId) {
    const folderId = folderDb.currentFolderId
    return folderId
  } else {
    return undefined
  }
}

export default useCurrentFolderId
